import {
  DefaultEntityFilters,
  EntityAutocompletePicker,
  EntityFilter,
} from '@backstage/plugin-catalog-react';
import { ANNOTATION_GITHUB_USER_LOGIN } from '@appfolio/backstage-plugin-catalog-common';

const FACET = `metadata.annotations.${ANNOTATION_GITHUB_USER_LOGIN}`;

class EntityUserGitHubUsernameFilter implements EntityFilter {
  public constructor(readonly values: string[]) {}

  public getCatalogFilters(): Record<string, string | string[]> {
    return { [FACET]: this.values };
  }

  public toQueryValue(): string[] {
    return this.values;
  }
}

export const EntityUserGitHubUsernamePicker = () => (
  <EntityAutocompletePicker<
    DefaultEntityFilters & {
      userGitHubUsername: EntityUserGitHubUsernameFilter;
    }
  >
    label="GitHub Username"
    name="userGitHubUsername"
    path={FACET}
    Filter={EntityUserGitHubUsernameFilter}
  />
);
